import * as React from "react";
import { useSetAtom } from "jotai";

import { outputFeedbackKey, outputFeedbackRatingsAtom } from "./atoms";
import { isFeedbackErr, listOutputFeedback } from "./feedbackClient";

/**
 * Loads the caller's existing ratings for a chat session so revisiting an
 * output shows the thumb they already picked.
 */
export function useOutputFeedbackHydration({ sessionId }: { sessionId?: string }) {
  const setRatings = useSetAtom(outputFeedbackRatingsAtom);

  React.useEffect(() => {
    if (!sessionId) return undefined;
    let cancelled = false;

    void listOutputFeedback({ sessionId }).then((result) => {
      if (cancelled || isFeedbackErr(result)) return;
      setRatings((current) => {
        const next = { ...current };
        for (const rating of result.data) {
          const key = outputFeedbackKey(rating);
          if (!(key in next)) next[key] = rating;
        }
        return next;
      });
    });

    return () => {
      cancelled = true;
    };
  }, [sessionId, setRatings]);
}
